// Toggle between showing and hiding the sidebar when clicking the menu icon
var mySidebar = document.getElementById("mySidebar");

// Close the sidebar with the close button
export function w3_close() {
    mySidebar.style.display = "none";
}